import { HITL_FEATURE_FLAG } from "@/features/hitl/presentPlan";
import { useFeatureFlag } from "./useFeatureFlag";

export function useHitlEnabled(): boolean {
  return useFeatureFlag(HITL_FEATURE_FLAG);
}
